import { useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import { Link, useLocation } from "react-router-dom";
import "./TelasNavegacao.css";
import Header from "./Header";
import iconLivrosSelecionados from "../imagem/iconLivrosSelecionados.svg";
import iconLivrosNaoSelecionados from "../imagem/iconLivrosNaoSelecionados.svg";
import iconDashboardSelecionados from "../imagem/iconDashboardSelecionados.svg";
import iconDashboardNaoSelecionados from "../imagem/iconDashboardNaoSelecionados.svg";
import iconAlunosSelecionados from "../imagem/iconAlunosSelecionados.svg";
import iconAlunosNaoSelecionados from "../imagem/iconAlunosNaoSelecionados.svg";
import iconEmprestimosSelecionados from "../imagem/iconEmprestimosSelecionados.svg";
import iconEmprestimosNaoSelecionados from "../imagem/iconEmprestimosNaoSelecionados.svg";
import iconSobreNaoSelecionado from "../imagem/iconSobreNaoSelecionado.svg";
import iconSobreSelecionado from "../imagem/iconSobreSelecionado.svg";
import iconBibliotecaAlunoNaoSelecionado from "../imagem/iconBibliotecaAlunoNaoSelecionado.svg";
import iconBibliotecaAlunoSelecionado from "../imagem/iconBibliotecaAlunoSelecionado.svg";
import iconChatIANaoSelecionado from "../imagem/iconChatIANaoSelecionado.svg";
import iconChatIASelecionado from "../imagem/iconChatIASelecionado.svg";
import iconDashboardAlunoNaoSelecionado from "../imagem/iconDashboardAlunoNaoSelecionado.png";
import iconDashboardAlunoSelecionado from "../imagem/iconDashboardAlunoSelecionado.png";
import iconPerfilAlunoNaoSelecionado from "../imagem/iconPerfilAlunoNaoSelecionado.svg";
import iconPerfilAlunoSelecionado from "../imagem/iconPerfilAlunoSelecionado.svg";
import iconRankingNaoSelecionado from "../imagem/iconRankingNaoSelecionado.svg";
import iconRankingSelecionado from "../imagem/iconRankingSelecionado.svg";
import iconTelaInicialNaoSelecionado from "../imagem/iconTelaInicialNaoSelecionado.svg";
import iconTelaInicialSelecionado from "../imagem/iconTelaInicialSelecionado.svg";
import iconSair from "../imagem/iconSair.svg";
import { useEffect, useState } from "react";
import { getRole } from "../services/api";
import DesejaSair from "../modais/DesejaSair";

function TelasNavegacao({ children }) {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [windowHeight, setWindowHeight] = useState(window.innerHeight);
  const [open, setOpen] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const navigate = useNavigate();
  const rota = useLocation();

  const user = getRole()

  const menus = [
    {
      link: "/dashboard",
      alt: "Dashboard",
      title: "Dashboard",
      roles: ["ADMIN", "FUNCIONARIO"],
      icones:
        rota.pathname === "/dashboard"
          ? iconDashboardNaoSelecionados
          : iconDashboardSelecionados,
    },
    {
      link: "/emprestimo",
      alt: "Empréstimos",
      title: "Empréstimos",
      roles: ["ADMIN", "FUNCIONARIO"],
      icones:
        rota.pathname === "/emprestimo"
          ? iconEmprestimosNaoSelecionados
          : iconEmprestimosSelecionados,
    },
    {
      link: "/livros",
      alt: "Livros",
      title: "Livros",
      roles: ["ADMIN", "FUNCIONARIO"],
      icones:
        rota.pathname === "/livros" ||
        rota.pathname.startsWith("/visualizacaoLivros")
          ? iconLivrosNaoSelecionados
          : iconLivrosSelecionados,
    },
    {
      link: "/alunos",
      alt: "Alunos",
      title: "Alunos",
      roles: ["ADMIN", "FUNCIONARIO"],
      icones:
        rota.pathname === "/alunos" ||
        rota.pathname.startsWith("/visualizacaoAlunos")
          ? iconAlunosNaoSelecionados
          : iconAlunosSelecionados,
    },
    {
      link: "/sobre",
      alt: "Sobre",
      title: "Sobre",
      roles: ["ADMIN", "FUNCIONARIO"],
      icones:
        rota.pathname === "/sobre"
          ? iconSobreSelecionado
          : iconSobreNaoSelecionado,
    },
    {
      link: "/telaInicial",
      alt: "Tela Inicial",
      title: "Tela Inicial",
      roles: ["ALUNO"],
      icones:
        rota.pathname === "/telaInicial"
          ? iconTelaInicialSelecionado
          : iconTelaInicialNaoSelecionado,
    },
    {
      link: "/ranking",
      alt: "Ranking",
      title: "Ranking",
      roles: ["ALUNO"],
      icones:
        rota.pathname === "/ranking"
          ? iconRankingSelecionado
          : iconRankingNaoSelecionado,
    },
    {
      link: "/minhaBibliotecaAluno",
      alt: "Minha Biblioteca",
      title: "Minha Biblioteca",
      roles: ["ALUNO"],
      icones:
        rota.pathname === "/minhaBibliotecaAluno"
          ? iconBibliotecaAlunoSelecionado
          : iconBibliotecaAlunoNaoSelecionado,
    },
    {
      link: "/perfilAluno",
      alt: "Minha Página",
      title: "Minha Página",
      roles: ["ALUNO"],
      icones:
        rota.pathname === "/perfilAluno"
          ? iconPerfilAlunoSelecionado
          : iconPerfilAlunoNaoSelecionado,
    },
    {
      link: "/chatIA",
      alt: "Chat IA",
      title: "Chat IA",
      roles: ["ALUNO"],
      icones:
        rota.pathname === "/chatIA"
          ? iconChatIASelecionado
          : iconChatIANaoSelecionado,
    },
    {
      link: "/dashboardAluno",
      alt: "Minha Trajetória de Leitura",
      title: "Minha Trajetória de Leitura",
      roles: ["ALUNO"],
      icones:
        rota.pathname === "/dashboardAluno"
          ? iconDashboardAlunoSelecionado
          : iconDashboardAlunoNaoSelecionado,
    },
    {
      link: "/sobreAluno",
      alt: "Sobre",
      title: "Sobre",
      roles: ["ALUNO"],
      icones:
        rota.pathname === "/sobreAluno"
          ? iconSobreSelecionado
          : iconSobreNaoSelecionado,
    },
  ];

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
      setWindowHeight(window.innerHeight);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const CaminhoLogin = () => {
    localStorage.removeItem("authToken");
    navigate("/login");
  };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "none",
    boxShadow: 24,
    height: 156,
    p: 4,
    borderRadius: 3,
  };

  return (
    <div style={{width: '100%', height: '100%', overflow: 'none'}}>
      <DesejaSair
        sair={CaminhoLogin}
        abrirModal={openModal}
        fechar={() => setOpenModal(false)}
      />
      <Header />
      <div className="container">
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            // height: `${windowHeight - 65}px`,
            width: "80px",
            borderRight: "1px solid var(--cor-cinzaMargin)",
            alignItems: "center",
            justifyContent: "space-between"
          }}
        >
          <div className="div_icones">
            {menus.map((menu) => {
              try {
                if (menu?.roles?.includes(user.role)) {
                  return (
                    <Link key={menu.link} to={menu.link}>
                      <img src={menu.icones} alt={menu.alt} title={menu.title} />
                    </Link>
                  );
                }
              } catch (err) {
                navigate("/login")
              }
            })}
          </div>

          <div className="btn_sair">
            <Button
              className="sair"
              onClick={() => setOpenModal(true)}
              title="Sair"
            >
              <img src={iconSair} alt="Sair" />
            </Button>
          </div>
        </div>
        <div
          style={{
            width: `${windowWidth - 80}px`,
            height: `${windowHeight - 65}px`,
            overflow: 'auto',
          }}
        >
          {children}
        </div>
      </div>
    </div>
  );
}

export default TelasNavegacao;
